import { UserRoles } from '@/enums/enums';
import { Permission } from '@/enums/permissions';

import { TenantModule } from '@/types/settings.types';
import { AccessOptions } from '@/components/guards/use-access';

export const Access = {
  AadeMyData: {
    module: TenantModule.AadeMyData,
    roles: [UserRoles.Root, UserRoles.Admin, UserRoles.Secretary],
    restrictedRoles: [UserRoles.Secretary],
    permission: Permission.UseAadeMyData,
  },
  ManageStudents: {
    roles: [UserRoles.Root, UserRoles.Admin, UserRoles.Secretary],
    restrictedRoles: [UserRoles.Secretary],
    permission: Permission.ManageStudents,
  },
  CreateLesson: {
    roles: [UserRoles.Root, UserRoles.Admin, UserRoles.Teacher],
    restrictedRoles: [UserRoles.Teacher],
    permission: Permission.CreateLesson,
  },
  ManageContracts: {
    roles: [UserRoles.Root, UserRoles.Admin, UserRoles.Secretary],
    restrictedRoles: [UserRoles.Secretary],
    permission: Permission.ManageContracts,
  },
  Requests: {
    module: TenantModule.Requests,
    roles: [
      UserRoles.Root,
      UserRoles.Admin,
      UserRoles.Secretary,
      UserRoles.Teacher,
      UserRoles.Parent,
    ],
  },

  StudentsExcelImport: {
    roles: [UserRoles.Root],
  },
  DeleteStudents: {
    roles: [UserRoles.Root, UserRoles.Admin, UserRoles.Secretary],
  },
} as const satisfies Record<string, AccessOptions>;
